import { Badge } from "@/components/ui/badge";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";

interface TotalAmountProps {
  amount: number;
  counted?: number;
  isValidated?: boolean;
  transactions?: Array<{
    promotion_id?: string | null;
  }>;
}

export const TotalAmount = ({ amount, counted, isValidated, transactions = [] }: TotalAmountProps) => {
  const { data: currencySymbol } = useOwnerCurrency();
  const isAmountEqual = counted === amount;
  const isAmountValidated = isValidated && isAmountEqual;

  return (
    <div className="flex items-center gap-4 mt-1">
      <div className="text-2xl font-bold">
        {amount.toLocaleString()} {currencySymbol}
      </div>
      {counted !== undefined && (
        <div className="flex items-center gap-2">
          <div 
            className={`text-2xl font-bold ${
              isAmountValidated ? 'text-green-600' : 'text-orange-500'
            }`}
          >
            {counted.toLocaleString()} {currencySymbol}
            {isAmountValidated && (
              <Badge className="ml-2 bg-green-600">Validé</Badge>
            )}
          </div>
        </div>
      )}
    </div>
  );
};